import { Declaration } from 'store/declarations/declaration';
import { DeclarationExternalEntity } from 'store/declarations/enums/common/declaration-external-entity';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { NctsDeclaration } from '../../../../store/declarations/ireland/ncts-declaration';
import { TemplateOptions } from './TemplateContext';

const getDeclarationForTemplate = (options: TemplateOptions): Declaration | null => {
    if (options.country === 'IRELAND' || options.country === 'REVENUE') {
        if (options.declarationType === 'IMPORT') {
            if (options.formType === 'H1' || options.formType === 'I1') {
                return {
                    irelandImportDeclaration: { messageType: options.formType as any },
                    declarationExternalEntity: DeclarationExternalEntity.REVENUE,
                    declarationInternalType: DeclarationInternalType.IMPORT,
                    status: 'DRAFT',
                };
            } else if (options.formType === 'H7') {
                return {
                    irelandH7ImportDeclaration: {},
                    declarationExternalEntity: DeclarationExternalEntity.REVENUE,
                    declarationInternalType: DeclarationInternalType.IMPORT,
                    status: 'DRAFT',
                };
            }
        } else if (options.declarationType === 'ENS') {
            return {
                entrySummaryDeclaration: {},
                declarationExternalEntity: DeclarationExternalEntity.REVENUE,
                declarationInternalType: DeclarationInternalType.ENS,
                status: 'DRAFT',
            };
        } else if (options.declarationType === 'EXPORT') {
            return {
                ieExportDeclaration: {},
                declarationExternalEntity: DeclarationExternalEntity.REVENUE,
                declarationInternalType: DeclarationInternalType.EXPORT,
                status: 'DRAFT',
            };
        } else if (options.declarationType === 'NCTS') {
            return {
                ieNctsDeclaration: {} as NctsDeclaration,
                declarationExternalEntity: DeclarationExternalEntity.REVENUE,
                declarationInternalType: DeclarationInternalType.NCTS,
                status: 'DRAFT',
            };
        }
    }
    if (options.country === 'EU') {
        return {
            ics2ENSDeclaration: { messageType: options.formType as any },
            declarationExternalEntity: DeclarationExternalEntity.ICS2,
            declarationInternalType: DeclarationInternalType.ENS,
            status: 'DRAFT',
        };
    }
    if (options.country === 'UK' || options.country === 'CDS') {
        if (options.declarationType === 'EXPORT') {
            return {
                cdsDeclaration: {},
                declarationExternalEntity: DeclarationExternalEntity.CDS,
                declarationInternalType: DeclarationInternalType.EXPORT,
                status: 'DRAFT',
            };
        } else if (options.declarationType === 'IMPORT') {
            return {
                cdsDeclaration: {},
                declarationExternalEntity: DeclarationExternalEntity.CDS,
                declarationInternalType: DeclarationInternalType.IMPORT,
                status: 'DRAFT',
            };
        } else if (options.declarationType === 'NCTS') {
            return {
                ukNctsDeclaration: {} as NctsDeclaration,
                declarationExternalEntity: DeclarationExternalEntity.HMRC,
                declarationInternalType: DeclarationInternalType.NCTS,
                status: 'DRAFT',
            };
        }
    }
    return null;
};

const parseTemplateOptions = (options: TemplateOptions | undefined) => {
    if (!options) return {};

    const country = options.country?.toLowerCase();
    const declarationType = options.declarationType?.toLocaleLowerCase();

    const path = `${country === 'uk' ? 'cds' : country}/${declarationType}`;
    const declaration = getDeclarationForTemplate(options);

    return { path, declaration };
};

export default parseTemplateOptions;
